import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { ExperienceAreaService } from '../../../experience-area.service';
import { ExperienceCoursesService } from '../../experience-courses.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'experience-courses-accelerator-enrollments-view-part',
	standalone: true,
	templateUrl: './accelerator-enrollments-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		GridContentWidget
	]
})
export class ExperienceCoursesAcceleratorEnrollmentsViewPart {

	private readonly service = inject(ExperienceCoursesService);
	private readonly areaService = inject(ExperienceAreaService);
	private util = inject(UtilityService);

	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.service.layout()) return { layout: this.service.layout()!, viewSelector: true };
		return undefined;
	});

	public readonly enrollments = computed(() => this.areaService.experienceData()?.acceleratorEnrollments ?? []);

}
